//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { CustomFieldInputItem } from './CustomFieldInputItem';
import { ICustomFieldWithRequired } from './ICustomFieldWithRequired';
import { ICustomFieldWithHint } from './ICustomFieldWithHint';
import { CustomFieldType } from './Enums';

export class CustomFieldTextInputItem extends CustomFieldInputItem implements ICustomFieldWithRequired, ICustomFieldWithHint {
    Required: boolean = false;
    Hint: string | null = null;
    override readonly FieldType: CustomFieldType = CustomFieldType.Text;

    constructor(initializer?: Partial<Omit<CustomFieldTextInputItem, "FieldType">>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "CustomFieldTextInputItem";
}
